export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/50 blur-3xl"></div>
        <div className="absolute -bottom-60 -left-40 w-[500px] h-[500px] rounded-full bg-accent-100/40 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>全网热门漫画免费看</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading leading-tight">
              虫虫漫画网
              <br />
              <span className="text-primary-500">免费漫画在线阅读平台</span>
            </h1>

            <p className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              虫虫漫画网汇聚海量<strong>免费漫画</strong>资源，涵盖<strong>韩漫</strong>、<strong>日漫</strong>、<strong>国漫</strong>等全品类内容。
              支持<strong>全集漫画下拉式阅读</strong>，无需翻页，畅快连读。每日同步更新，第一时间追更你喜欢的<strong>好看的漫画</strong>推荐。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-book-2-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">10万+</div>
                  <div className="text-xs text-foreground-500">漫画资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-group-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">500万+</div>
                  <div className="text-xs text-foreground-500">活跃读者</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-timer-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">每日更新</div>
                  <div className="text-xs text-foreground-500">同步连载</div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-xl transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                立即探索热门漫画
              </a>
              <a
                href="#topics"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-medium text-foreground-700 bg-background-100 hover:bg-background-200 rounded-xl transition-all duration-200 whitespace-nowrap text-center cursor-pointer border border-background-200"
              >
                浏览话题标签
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20manga%20comic%20illustration%20featuring%20dynamic%20action%20scene%20with%20multiple%20characters%20in%20various%20art%20styles%2C%20warm%20red%20and%20orange%20toned%20background%2C%20Japanese%20and%20Chinese%20comic%20aesthetic%2C%20clean%20vibrant%20colors%2C%20modern%20digital%20illustration%20style%2C%20suitable%20for%20manga%20reading%20platform%20hero%20image&width=680&height=920&seq=hero-manga-2026-x1&orientation=portrait"
                alt="虫虫漫画网 - 海量免费漫画在线阅读"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}